<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import EditableTypedInput from '@/components/Fields/EditableTypedInput.vue'
import { localFallback } from '@/locales/langUtils'
import { type ExtendedPrimitives } from '@/types/ExtendedPrimitives'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import type { ConfigType } from '@/types/models/PartnerConfigModel'
import type { PartnerModel } from '@/types/partners/PartnerModel'

type Props = {
    isInEditMode?: boolean
    partnerConfig?: PartnerModel
    partnerConfigValue?: Record<string, ExtendedPrimitives> | null
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<CheckpointModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <InformationBaseCard
        v-if="partnerConfig"
        :label="partnerConfig.name"
        class="full-width fit-height">
        <EditableTypedInput
            v-for="([itemKey, itemValue], key) in Object.entries(
                partnerConfig?.config?.checkpoint ?? {}
            )"
            :key="key"
            :label="
                (itemValue as ConfigType)?.label
                    ? localFallback((itemValue as ConfigType)?.label) ?? itemKey
                    : itemKey
            "
            :value="partnerConfigValue?.[itemKey]"
            :dataType="(itemValue as ConfigType)?.type ?? itemValue"
            :isInEditMode="isInEditMode"
            required
            @change="
                $emit('change', {
                    partner_config: { ...(partnerConfigValue ?? {}), [itemKey]: $event }
                })
            " />
    </InformationBaseCard>
</template>
